import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpHeadersPortal, HttpService } from '../../../core/http/http.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ResultCoutAfiCat } from '../../../core/models/mass-queries/result-cout-afi-cat';
import { GeneralResponse } from '../../../core/models/general-response/general-response';
import { IaffiliationsNumber } from '../../../core/models/business-information/iaffiliations-number';

@Injectable({
	providedIn: 'root'
})
export class MassQueriesService {
	public dataInfo;

	constructor(private _http: HttpService) { }

	setDataInfo(data) {
		this.dataInfo = data;
	}

	getDataInfo() {
		return this.dataInfo;
	}

	getHeadersAuthorization() {
		const headers: HttpHeadersPortal = {
			AUTHORIZATION: environment.AFILIACION_MASIVA.REPORTE_MASIVO_AUTH
		}

		return headers;
	}

	getData(data):Observable<any>{
		const params = {
	      nit: data.idEmpresa
	    };

	  return this._http.get(
	      environment.AFILIACION_MASIVA.REPORTE_MASIVO_API_URL,
	      '/consultas',
	      params,
	      this.getHeadersAuthorization()
	    ).pipe(
	      map((response) => {
	        return response;
	      })
	   );
	}


	getContAfiCatGen(nit:string):Observable<ResultCoutAfiCat> {
		const params = {nit};

	   	return this._http.get(
	      environment.AFILIACION_MASIVA.REPORTE_MASIVO_CONTEO,
	      '/conteo/afiliados/genero/categoria',
	      params,
	      this.getHeadersAuthorization()
	    ).pipe(
	      map((response) => {
	        return (response as GeneralResponse<ResultCoutAfiCat>).body;
	      })
	    );
	}

	getNumAffiliations(typeDoc: string,numDoc: string):Observable<IaffiliationsNumber>{
		const params = {
			typeDoc,numDoc
		  };

		  return this._http.get(
			environment.AFILIACION_MASIVA.REPORTE_MASIVO_CONTEO,
			'/conteo/afiliados',
			params,
			this.getHeadersAuthorization()
		  ).pipe(
			map((response) => {
			  return (response as GeneralResponse<IaffiliationsNumber>).body;
			})
		  );
	}

	search(data) {		return this._http.post(
			environment.AFILIACION_MASIVA.REPORTE_MASIVO_API_URL,
	      '/publicar/consulta',
	      data,
	      {},
	      this.getHeadersAuthorization()
	    ).pipe(
	      map((response) => {
	        return response;
	      })
	    );
	}

  getFileXExcel(startMonth: string, startYear: string, endMonth: string, endYear: string, numDoc: string, typeDoc: string): Observable<any> {
    const headers: HttpHeadersPortal = {
		CONTENT_TYPE:  'application/vnd.ms-excel'
	};

    return this._http.downloadFileFromGet(
		'http://localhost:7071/api',
		'/descarga/',
		{startMonth,startYear},
		headers
	).pipe(
      map((response) => {
        return (response);
      })
    );
  }
}
